import { useState } from 'react';
import PageShell from '../../components/feature/PageShell';
import PageHero from '../../components/feature/PageHero';

interface GalleryItem {
  id: number;
  category: string;
  title: string;
  before: string;
  after: string;
  description: string;
}

const galleryItems: GalleryItem[] = [
  {
    id: 1,
    category: 'Rehabilitación',
    title: 'Restauración completa de sonrisa',
    before: 'https://readdy.ai/api/search-image?query=dental%20before%20photo%20stained%20damaged%20teeth%20yellow%20worn%20cavity%20decay%20realistic%20close%20up%20mouth%20open%20showing%20damaged%20teeth%20dental%20problem%20before%20treatment&width=560&height=400&seq=gallery-before-001&orientation=landscape',
    after: 'https://readdy.ai/api/search-image?query=dental%20after%20photo%20perfect%20white%20bright%20clean%20teeth%20beautiful%20smile%20result%20after%20dental%20treatment%20restoration%20perfect%20teeth%20close%20up%20mouth&width=560&height=400&seq=gallery-after-001&orientation=landscape',
    description: 'Rehabilitación oral completa con coronas de porcelana y blanqueamiento profesional.',
  },
  {
    id: 2,
    category: 'Ortodoncia',
    title: 'Corrección con brackets',
    before: 'https://readdy.ai/api/search-image?query=dental%20before%20photo%20crooked%20misaligned%20overcrowded%20teeth%20orthodontic%20problem%20before%20braces%20realistic%20close%20up%20smile%20dental%20issue&width=560&height=400&seq=gallery-before-002&orientation=landscape',
    after: 'https://readdy.ai/api/search-image?query=dental%20after%20photo%20perfectly%20aligned%20straight%20teeth%20beautiful%20smile%20after%20orthodontic%20treatment%20braces%20result%20white%20teeth%20close%20up&width=560&height=400&seq=gallery-after-002&orientation=landscape',
    description: 'Corrección de apiñamiento dental severo con brackets metálicos en 18 meses.',
  },
  {
    id: 3,
    category: 'Implantes',
    title: 'Implante dental unitario',
    before: 'https://readdy.ai/api/search-image?query=dental%20before%20photo%20missing%20tooth%20gap%20space%20in%20mouth%20before%20implant%20realistic%20clinical%20photo%20dental%20issue%20tooth%20loss%20problem&width=560&height=400&seq=gallery-before-003&orientation=landscape',
    after: 'https://readdy.ai/api/search-image?query=dental%20after%20photo%20implant%20crown%20perfect%20smile%20no%20gap%20beautiful%20restoration%20result%20after%20dental%20implant%20natural%20looking%20tooth%20perfect%20alignment&width=560&height=400&seq=gallery-after-003&orientation=landscape',
    description: 'Implante de titanio con corona de porcelana, resultado completamente natural.',
  },
  {
    id: 4,
    category: 'Estética',
    title: 'Blanqueamiento profesional',
    before: 'https://readdy.ai/api/search-image?query=dental%20before%20photo%20yellow%20stained%20discolored%20teeth%20coffee%20tea%20stains%20before%20whitening%20treatment%20realistic%20clinical%20photo%20dental%20aesthetics&width=560&height=400&seq=gallery-before-004&orientation=landscape',
    after: 'https://readdy.ai/api/search-image?query=dental%20after%20photo%20bright%20white%20dazzling%20smile%20result%20after%20professional%20teeth%20whitening%20perfect%20pearly%20white%20teeth%20beautiful%20clean%20result&width=560&height=400&seq=gallery-after-004&orientation=landscape',
    description: 'Blanqueamiento dental en consultorio con LED, 8 tonos más blanco en una sola sesión.',
  },
  {
    id: 5,
    category: 'Prótesis',
    title: 'Prótesis fija de zirconia',
    before: 'https://readdy.ai/api/search-image?query=dental%20before%20photo%20worn%20damaged%20old%20crowns%20dark%20metal%20edges%20failing%20dental%20work%20before%20crown%20replacement%20clinical%20photo%20realistic&width=560&height=400&seq=gallery-before-005&orientation=landscape',
    after: 'https://readdy.ai/api/search-image?query=dental%20after%20photo%20beautiful%20zirconia%20all%20ceramic%20crowns%20perfect%20white%20natural%20looking%20smile%20beautiful%20result%20premium%20dental%20prosthetics%20crown%20replacement&width=560&height=400&seq=gallery-after-005&orientation=landscape',
    description: 'Sustitución de coronas antiguas por nuevas coronas de zirconia de alta estética.',
  },
  {
    id: 6,
    category: 'Cirugía',
    title: 'Extracción y regeneración',
    before: 'https://readdy.ai/api/search-image?query=dental%20before%20photo%20infected%20tooth%20abscess%20problem%20wisdom%20tooth%20issue%20before%20extraction%20clinical%20realistic%20dental%20problem%20requiring%20surgery&width=560&height=400&seq=gallery-before-006&orientation=landscape',
    after: 'https://readdy.ai/api/search-image?query=dental%20after%20photo%20healthy%20gum%20tissue%20healed%20after%20surgery%20extraction%20beautiful%20healthy%20pink%20gums%20recovery%20complete%20dental%20surgery%20result&width=560&height=400&seq=gallery-after-006&orientation=landscape',
    description: 'Extracción quirúrgica de muela del juicio con regeneración ósea guiada.',
  },
];

const categories = ['Todos', 'Rehabilitación', 'Ortodoncia', 'Implantes', 'Estética', 'Prótesis', 'Cirugía'];

function GalleryCard({ item }: { item: GalleryItem }) {
  const [showAfter, setShowAfter] = useState(false);

  return (
    <div className="bg-white rounded-3xl overflow-hidden border border-gray-100 group hover:-translate-y-1 transition-all duration-300">
      {/* Before/After image toggle */}
      <div className="relative overflow-hidden" style={{ height: '240px' }}>
        <img
          src={item.before}
          alt={`Antes: ${item.title}`}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${showAfter ? 'opacity-0' : 'opacity-100'}`}
        />
        <img
          src={item.after}
          alt={`Después: ${item.title}`}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${showAfter ? 'opacity-100' : 'opacity-0'}`}
        />

        {/* Category badge */}
        <div className="absolute top-4 left-4 z-10">
          <span className="bg-[#0A2540]/80 backdrop-blur-sm text-white text-xs px-3 py-1 rounded-full font-medium">
            {item.category}
          </span>
        </div>

        {/* Toggle buttons */}
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-1 z-10 bg-[#0A2540]/70 backdrop-blur-sm rounded-full p-1">
          <button
            onClick={() => setShowAfter(false)}
            className={`px-4 py-1.5 rounded-full text-xs font-semibold transition-all cursor-pointer whitespace-nowrap ${
              !showAfter ? 'bg-white text-[#0A2540]' : 'text-white/70 hover:text-white'
            }`}
          >
            Antes
          </button>
          <button
            onClick={() => setShowAfter(true)}
            className={`px-4 py-1.5 rounded-full text-xs font-semibold transition-all cursor-pointer whitespace-nowrap ${
              showAfter ? 'bg-[#3A86FF] text-white' : 'text-white/70 hover:text-white'
            }`}
          >
            Después
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="p-5">
        <h3 className="font-bold text-[#0A2540] mb-2">{item.title}</h3>
        <p className="text-gray-500 text-sm leading-relaxed">{item.description}</p>
      </div>
    </div>
  );
}

export default function GaleriaPage() {
  const [activeCategory, setActiveCategory] = useState('Todos');

  const filtered = activeCategory === 'Todos'
    ? galleryItems
    : galleryItems.filter((item) => item.category === activeCategory);

  return (
    <PageShell>
      {(onOpenModal) => (
        <>
          <PageHero
            title="Galería &"
            highlight="Resultados"
            subtitle="Casos reales"
            bgImage="https://readdy.ai/api/search-image?query=beautiful%20smile%20transformation%20dental%20before%20after%20collage%20multiple%20dental%20cases%20results%20professional%20dental%20work%20showcase%20gallery%20montage%20clean%20white%20background&width=1920&height=600&seq=galeria-hero-001&orientation=landscape"
            breadcrumbs={[
              { label: 'Inicio', to: '/' },
              { label: 'Galería' },
            ]}
          />

          <section className="py-24 bg-white">
            <div className="max-w-7xl mx-auto px-6">
              <div className="text-center mb-12 scroll-animate">
                <span className="inline-block text-[#3A86FF] font-semibold text-sm tracking-widest uppercase mb-3">
                  Antes y después
                </span>
                <h2 className="text-4xl font-extrabold text-[#0A2540] mb-4">
                  Casos{' '}
                  <span className="bg-gradient-to-r from-[#3A86FF] to-[#0A2540] bg-clip-text text-transparent">
                    Reales
                  </span>
                </h2>
                <p className="text-gray-500 max-w-xl mx-auto font-light">
                  Cada sonrisa es única. Estos son algunos de los casos que hemos transformado en nuestra clínica.
                  Haz clic en "Antes / Después" para ver la diferencia.
                </p>
              </div>

              {/* Category filter */}
              <div className="flex flex-wrap justify-center gap-2 mb-12">
                {categories.map((cat) => (
                  <button
                    key={cat}
                    onClick={() => setActiveCategory(cat)}
                    className={`px-5 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                      activeCategory === cat
                        ? 'bg-[#0A2540] text-white'
                        : 'bg-[#f7f9fc] text-gray-600 hover:bg-gray-200 border border-gray-200'
                    }`}
                  >
                    {cat}
                  </button>
                ))}
              </div>

              {/* Grid */}
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
                {filtered.map((item) => (
                  <GalleryCard key={item.id} item={item} />
                ))}
              </div>

              {/* CTA */}
              <div className="mt-20 text-center scroll-animate">
                <div className="bg-[#f7f9fc] rounded-3xl p-10 border border-gray-100 max-w-2xl mx-auto">
                  <div className="w-16 h-16 flex items-center justify-center bg-[#3A86FF]/15 rounded-2xl mx-auto mb-5">
                    <i className="ri-camera-smile-line text-[#3A86FF] text-2xl" />
                  </div>
                  <h3 className="text-2xl font-bold text-[#0A2540] mb-3">
                    ¿Quieres ver tu transformación?
                  </h3>
                  <p className="text-gray-500 text-sm mb-6 leading-relaxed">
                    Agenda una consulta gratuita y te mostraremos cómo podemos transformar tu sonrisa.
                  </p>
                  <button
                    onClick={onOpenModal}
                    className="inline-flex items-center gap-2 bg-[#3A86FF] hover:bg-[#1a6aff] text-white px-8 py-3.5 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer hover:-translate-y-0.5"
                  >
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-calendar-check-line" />
                    </div>
                    Consulta Gratuita
                  </button>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </PageShell>
  );
}
